// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewChoproHeaderContent {
  display: flex;
  align-items: center;
  gap: 10px;
}

.viewChoproSongInfoButton {
  border: 1px solid #bfb8b2;
  border-radius: 6px;
  background-color: #f7f4f2;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
}

.viewChoproSongInfoButton:hover {
  background-color: #eee7e3;
}

.viewChoproSongInfoMenu {
  position: absolute;
  z-index: 10;
  background: #fff;
  border: 1px solid #bfb8b2;
  border-radius: 8px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
  padding: 15px;
  width: 290px;
  display: grid;
  gap: 8px;
  font-size: var(--font-size-small);
}

.viewChoproSongInfoGroup {
  display: grid;
  gap: 8px;
}

.viewChoproSongInfoGroupTitle {
  --spacing: 8px;
  margin-top: var(--spacing);
  padding-bottom: var(--spacing);
  padding-inline: var(--spacing);
  margin-bottom: var(--spacing);
  
  border-bottom: 1px solid #ccc;
}

.viewChoproSongInfoRow {
  display: grid;
  grid-template-columns: 70px 1fr;
  align-items: center;
  gap: 8px;
}

.viewChoproSongInfoLabel {
  text-align: right;
}

.viewChoproSongInfoInput {
  border: 1px solid #bfb8b2;
  border-radius: 6px;
  padding: 6px 8px;
}

.viewChoproSongInfoSelect {
  border: 1px solid #bfb8b2;
  border-radius: 6px;
  padding: 4px 6px;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/ViewChopro.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;;EAE7B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".viewChoproHeaderContent {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.viewChoproSongInfoButton {\n  border: 1px solid #bfb8b2;\n  border-radius: 6px;\n  background-color: #f7f4f2;\n  padding: 4px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.viewChoproSongInfoButton:hover {\n  background-color: #eee7e3;\n}\n\n.viewChoproSongInfoMenu {\n  position: absolute;\n  z-index: 10;\n  background: #fff;\n  border: 1px solid #bfb8b2;\n  border-radius: 8px;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);\n  padding: 15px;\n  width: 290px;\n  display: grid;\n  gap: 8px;\n  font-size: var(--font-size-small);\n}\n\n.viewChoproSongInfoGroup {\n  display: grid;\n  gap: 8px;\n}\n\n.viewChoproSongInfoGroupTitle {\n  --spacing: 8px;\n  margin-top: var(--spacing);\n  padding-bottom: var(--spacing);\n  padding-inline: var(--spacing);\n  margin-bottom: var(--spacing);\n  \n  border-bottom: 1px solid #ccc;\n}\n\n.viewChoproSongInfoRow {\n  display: grid;\n  grid-template-columns: 70px 1fr;\n  align-items: center;\n  gap: 8px;\n}\n\n.viewChoproSongInfoLabel {\n  text-align: right;\n}\n\n.viewChoproSongInfoInput {\n  border: 1px solid #bfb8b2;\n  border-radius: 6px;\n  padding: 6px 8px;\n}\n\n.viewChoproSongInfoSelect {\n  border: 1px solid #bfb8b2;\n  border-radius: 6px;\n  padding: 4px 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
